import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TuneIcon from "@mui/icons-material/Tune";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import TimelineIcon from "@mui/icons-material/Timeline";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SchoolIcon from "@mui/icons-material/School";

const items = [
  {
    icon: <TuneIcon />,
    title: "Scoring That Matches Your Standards",
    description:
      "Define separate scoring criteria for won and lost calls. Each parameter has its own weight - you decide what matters most, and the AI scores every call against that.",
  },
  {
    icon: <WarningAmberIcon />,
    title: "Red Flags Caught Automatically",
    description:
      "Write down the behaviors you never want to hear. The AI screens every call against your definitions and surfaces the concerns - without you listening for them.",
  },
  {
    icon: <TimelineIcon />,
    title: "Every Rep's Score History in One Place",
    description:
      "Each salesperson has their own profile showing call-by-call scores and trends over time. Know immediately who's improving and who needs attention.",
  },
  {
    icon: <HeadphonesIcon />,
    title: "Full Transcript + In-Browser Audio Replay",
    description:
      "Every call is transcribed and playable directly in the app. Read the transcript, jump to any moment in the recording, and never miss context.",
  },
  {
    icon: <PictureAsPdfIcon />,
    title: "One-Click PDF Reports",
    description:
      "Export a complete analysis as a clean PDF - scores, AI summary, strengths, red flags, and manager notes included. Ready to use in your 1-on-1s.",
  },
  {
    icon: <SchoolIcon />,
    title: "Ramp New Reps in Half the Time",
    description:
      "Build a library of your best calls. Let new hires learn from real examples of what good looks like - not just a slide deck.",
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: "white",
        bgcolor: "grey.900",
      }}
    >
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Built for the Details That Close Deals
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.400" }}>
            Every feature exists because a sales manager asked for it. No fluff, no vanity metrics - just
            the tools that actually change how your team performs.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: "inherit",
                  p: 3,
                  height: "100%",
                  borderColor: "hsla(220, 25%, 25%, 0.3)",
                  backgroundColor: "grey.800",
                }}
              >
                <Box sx={{ opacity: "50%" }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: "medium" }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "grey.400" }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
